export enum BillingsTaxiDriverContributionContractCorrectionType {
  BASE_AMOUNT_EXTERNAL_TAXI = "BASE_AMOUNT_EXTERNAL_TAXI",
  CONTRACT_CORRECTION_RATE = "CONTRACT_CORRECTION_RATE",
}

export type BillingsTaxiDriverContributionContractCorrectionDummy = {
  type: null;
  rate: number | null;
  distance: number | null;
  amount: number | null;
};

export type BillingsTaxiDriverContributionContractCorrectionRate = {
  type: BillingsTaxiDriverContributionContractCorrectionType.CONTRACT_CORRECTION_RATE;
  rate: number | null;
};

export type BillingsTaxiDriverContributionBaseAmountExternalTaxi = {
  type: BillingsTaxiDriverContributionContractCorrectionType.BASE_AMOUNT_EXTERNAL_TAXI;
  distance: number | null;
  amount: number | null;
};

export type BillingsTaxiDriverContributionContractCorrectionReal =
  | BillingsTaxiDriverContributionContractCorrectionRate
  | BillingsTaxiDriverContributionBaseAmountExternalTaxi;

type BillingsTaxiDriverContributionContractCorrection =
  | BillingsTaxiDriverContributionContractCorrectionReal
  | BillingsTaxiDriverContributionContractCorrectionDummy;

export default BillingsTaxiDriverContributionContractCorrection;
